var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSectionBlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 859 282",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M859 0V282H436V0H859ZM91 143H0V130H91V143ZM45.5 122H0V109H45.5V122ZM409.5 102H0V89H409.5V102ZM416 82H0V69H416V82ZM187 61H0V44H187V61ZM399.5 37H0V20H399.5V37ZM54 12H0V0H54V12Z",
  fill: "#DFDFDF"
})));
export default SvgSectionBlock;